// extracted by mini-css-extract-plugin
export default {"coverRepositionModeOverlay":"w4YNPF","coverImage":"FE6SiB","cover":"yGToTM","coverIsLoading":"FnKL6G","withCoverColor":"cNOYMw"};